/**
 * getSegmentPageContext
 *
 * Segment's own automatic context.page enrichment doesn't reliably pick up
 * a client-side route change -- it keeps attaching whatever page was
 * current when the library initialized. Build it fresh from the current
 * document/location and pass it explicitly via the `context` option on
 * analytics.page()/analytics.track() calls instead of relying on that.
 *
 * document.referrer never updates on a Gatsby client-side route change --
 * it stays pinned to whatever referred the initial document load, so it's
 * only accurate as the referrer for that first page. Callers tracking an
 * in-app navigation (which has its own previous-page URL available) should
 * pass it as `referrer` to override that default.
 *
 * @param {object} [options]
 * @param {string} [options.referrer] - overrides document.referrer, e.g. with
 *   the in-app previous page's URL on a client-side route change
 * @returns {object}
 */
export function getSegmentPageContext({ referrer } = {}) {
  return {
    path: window.location.pathname,
    url: window.location.href,
    search: window.location.search,
    title: document.title,
    referrer: referrer !== undefined ? referrer : document.referrer,
  };
}
